export default __webpack_public_path__ + "static/media/Catraca Entrada.d7925ead.svg";